import { render, staticRenderFns } from "./socialsignin.vue?vue&type=template&id=0f66d56b&scoped=true&"
import script from "./socialsignin.vue?vue&type=script&lang=js&"
export * from "./socialsignin.vue?vue&type=script&lang=js&"
import style0 from "./socialsignin.vue?vue&type=style&index=0&id=0f66d56b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66d56b",
  null
  
)

component.options.__file = "socialsignin.vue"
export default component.exports